<script setup>
import {onBeforeUnmount, onMounted, ref} from 'vue';
import Button from "../../components/forms/Button.vue";
import {useRouter} from "vue-router";
import DocumentService from "@/services/DocumentService";
import FileView from "@/components/files/FileView.vue";
import {createConfirmDialog} from 'vuejs-confirm-dialog';
import SignModal from '@/components/modals/SignModal.vue';
import {showSuccessMessage} from '@/helper';
import {getLoggedUser} from '@/services/AuthService';
import {useI18n} from 'vue-i18n';

const {t} = useI18n()
const props = defineProps({
  documentId: {
    type: Number,
    default: null,
  },
  isModal: {
    type: Boolean,
    default: false,
  },
  isNewOnboarding: {
    type: Boolean,
    default: false,
  },
});

const document = ref( null);
const router = useRouter();
const documentId = props.documentId || router.currentRoute.value.params.id;
let refreshInterval = ref(null);
// IMA-511: klient ve stavu Inheritance_process/Inheritance_closed/Invalid má jen náhled -
// podepisování je zápis, backend by ho zamítl (403).
const isReadOnly = ref(false);
getLoggedUser().then(user => {
  isReadOnly.value = !!user?.client?.is_read_only;
});

onMounted(() => {
  getDocument(documentId);
});

onBeforeUnmount(() => {
  clearInterval(refreshInterval);
});

function getDocument(documentId) {
  DocumentService.getDocument(documentId, 'default,states')
      .then((response) => {
        document.value = response;
        if (response.is_generating || !response.file) {
          runRefreshInterval()
        }
      })
      .catch((error) => {
        console.log(error);
      });
}

function runRefreshInterval() {
  refreshInterval = setInterval(() => {
    DocumentService.getDocument(documentId, 'default,states')
        .then((response) => {
          document.value = response;
          if (!response.is_generating && response.file) {
            clearInterval(refreshInterval);
          }
        })
        .catch((error) => {
          console.log(error);
        });
  }, 3000);
}

function openSignModal() {
  const {reveal, onConfirm} = createConfirmDialog(SignModal, {documentsIds: [documentId]});
  reveal();
  onConfirm(() => {
    showSuccessMessage(t('documentsDetailSimple.documents_successfully_signed'));
    getDocument(documentId);
  });
}

</script>

<template>
  <div class="page-section">
    <div class="page-section__heading">
      <div class="row">
        <div class="col-2">
          <a v-if="!isModal" @click="router.back()" class="page-section__heading__back"><i class="mdi mdi-arrow-left"></i> {{ t('documentsDetailSimple.back') }}</a>
        </div>
        <div class="col-8 text-center">
          <div class="page-section__title">
            {{ document?.name }}
          </div>
        </div>
        <div class="col-2" v-if="document && document.signature_current_user && document.signature_current_user.state === 'PENDING' && !isNewOnboarding && !isReadOnly">
          <Button :label="t('documentsDetailSimple.sign_document2')" @click="openSignModal" />
        </div>
      </div>
    </div>

    <div class="page-section__content">
      <div class="row" v-if="document && document.file">
        <FileView :isNewOnboarding="isNewOnboarding" :file="document.file"/>
      </div>
      <div class="row pt-5" v-else>
        <div class="col-12 d-flex justify-content-center align-items-center">
          <div class="loader spinner-border text-primary me-3"> </div>
          {{ t('documentsDetailSimple.pending_document_generation') }}
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>
